import { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Grid,
  FormHelperText,
  TextField,
  Divider,
  CardContent,
} from '@material-ui/core';
import RegionSelector from './RegionSelector';

const selectNotificationTo = [
  { value: 'all washers', label: 'All Washers' },
  { value: 'online washers', label: 'Online Washers' },
  { value: 'all users', label: 'All Users' },
  { value: 'inactive users', label: 'Inactive Users' },
  { value: 'region', label: 'Users in Region' },
];

const SmsConfiguration = (props) => {
  const [region, setRegion] = useState({ concelho: '', freguesia: '' });

  return (
    <Card>
      <CardHeader title="Send SMS Notification" />
      <Divider />
      <CardContent>
        <Formik
          initialValues={{
            send_to: selectNotificationTo[0].value,
            message: '',
          }}
          validationSchema={Yup.object().shape({
            send_to: Yup.string().required('Please select one'),
            message: Yup.string().required('Please enter a message'),
          })}
          onSubmit={(values) => {
            const payload = { ...values };
            if (values.send_to === 'region') {
              if (!region.concelho) {
                // eslint-disable-next-line no-alert
                window.alert('Pick a municipality first.');
                return;
              }
              payload.region = region;
            }
            props.handleSmsNotification(payload);
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2} justifyContent="flex-start">
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Select Notification To"
                    name="send_to"
                    onChange={handleChange}
                    required
                    select
                    SelectProps={{ native: true }}
                    value={values.send_to}
                    variant="outlined"
                  >
                    {selectNotificationTo.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6} sm={12}>
                  <TextField
                    error={Boolean(touched.message && errors.message)}
                    fullWidth
                    helperText={touched.message && errors.message}
                    label="Enter Message"
                    name="message"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.message}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              {values.send_to === 'region' && (
                <Box pt={2}>
                  <RegionSelector value={region} onChange={setRegion} label="Target region" />
                </Box>
              )}
              {Boolean(touched.policy && errors.policy) && (
                <FormHelperText error>{errors.policy}</FormHelperText>
              )}
              <Box paddingY={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      size="large"
                      fullWidth
                      type="submit"
                      variant="contained"
                    >
                      SEND SMS NOTIFICATION
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
};

SmsConfiguration.propTypes = {
  handleSmsNotification: PropTypes.func,
};

export default SmsConfiguration;
